import React from 'react';
import {PagingProvider, SearchProvider} from '@thinkwell/react.common';
import {AppProvider} from '@thinkwell/react.polaris';
import { CoursesProvider } from '../contexts/Courses'
import Courses from './Courses'

export default function Index(props) {
  return ( <AppProvider>
    <SearchProvider search={props.query}>
    <PagingProvider previous_page_info={props.previous_page_info} next_page_info={props.next_page_info} page={props.page}>
    <CoursesProvider value={props.items}>
      <Courses />
    </CoursesProvider>
    </PagingProvider>
    </SearchProvider></AppProvider>)
}
